import { Component, OnInit, Input } from '@angular/core';

@Component({
	selector: 'app-chat-message-button-link',
	templateUrl: './chat-message-button-link.component.html',
	styleUrls: ['./chat-message-button-link.component.scss']
})
export class ChatMessageButtonLinkComponent implements OnInit {

	@Input() index: number;
	@Input() elements: any;

	constructor() { }

	ngOnInit() { }

	openUrl(item: any) {
		let url: string = '';
		if (!/^http[s]?:\/\//.test(item.intent)) {
			url += 'http://';
		}
		url += item.intent
		window.open(url, "_blank");
	}

}
